import React, { memo } from 'react';
import Div from '../Div';
import ChevronRight from '@/components/Icons/ChevronRight';
import classNames from 'classnames';
import Images from '../Image';
import { parseMediaFromCMS } from '@/utils/image';
import CTAs from './CTAs';
import is from '@/utils/is';

export interface InformationCardProps {
  dataTestId: string;
  title: string;
  subTitle: string;
  ctas: any[];
  icon: {
    src: string;
    data: {
      attributes: {
        width: number;
        height: number;
        alternativeText: string;
      };
    };
  };
  className?: string;
}

const InformationCard = (props: InformationCardProps) => {
  const { dataTestId, title, subTitle, ctas, icon, className } = props;
  return (
    <Div
      dataTestId={dataTestId}
      className={classNames(
        'flex-1 px-s4 py-s5 lg:px-s5 lg:py-s6 border border-solid border-co-subtle rounded-cs bg-cs-primary relative',
        className,
      )}
    >
      <Div className="w-s6 lg:w-14">
        <Images
          alt={icon?.data?.attributes?.alternativeText}
          src={parseMediaFromCMS(icon).src}
          // placeholder="blur"
          blurDataURL={parseMediaFromCMS(icon).src}
          width={icon?.data?.attributes?.width}
          height={icon?.data?.attributes?.height}
          className="object-cover"
        />
      </Div>
      <Div className="text-h-3 text-cti-primary lg:text-hd-3 mt-s4 lg:mt-s5 ">{title}</Div>
      <Div className="text-body-base lg:text-body-lg text-cti-secondary mt-s3">{subTitle}</Div>
      <Div className="py-s4" forceRender={is.not.empty.array(ctas)} />
      <CTAs
        list={ctas || []}
        dataTestId="information-card"
        className="!text-button-small !justify-start !gap-s2 inline-flex !pb-0 absolute bottom-s5 left-s5"
        attribute={
          <Div className="w-s5">
            <ChevronRight />
          </Div>
        }
      />
    </Div>
  );
};

export default memo(InformationCard);
